export default {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  PAYMENT: 'PAYMENT',
};
